import React from "react";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";

import "./Page404.scss";
import useTheme from "../../services/theme-service/ThemeService";
import { translationService } from "../../services/translation/TranslationService";
import useMainMenuService, {
  DASHBOARD,
  MainMenuItemCategory,
} from "../../services/main-menu/MainMenuService";
import { currentUserService } from "../../services/user/CurrentUserStorage";

const getPageName = (page: MainMenuItemCategory) =>
  page.name === DASHBOARD && !currentUserService.userIsPartOfAnOrganization
    ? "general.homepage"
    : `general.${page.name}`;

const getPageLink = (page: MainMenuItemCategory) =>
  page.name !== DASHBOARD ? `/${page.path || page.name}` : "/";

export default observer(function Page404() {
  const { themeClass } = useTheme();
  const { menuCategories } = useMainMenuService();

  return (
    <div className={themeClass(["page-404"])}>
      <div className="content">
        <p className="status-code">404</p>
        <p className="not-found">{translationService.translate("Page404.not-found")}</p>
        <p>{translationService.translate("Page404.inexistent")}</p>
        <p>{translationService.translate("Page404.return-to")}</p>
        <div className="main-pages">
          {menuCategories.map(
            (page) =>
              page.canAccess && (
                <Link key={page.name} to={getPageLink(page)}>
                  {translationService.translate(getPageName(page))}
                </Link>
              )
          )}
        </div>
      </div>
    </div>
  );
});
